export const PROJECT_EDIT_BACK_DEFAULT_ROUTE = 'project/my-projects';

export const ALL_PROJECTS_ROUTE = '/all-projects';

export const PROJECT_BASE_ROUTE = '/project';
